import { memo, useCallback, useMemo, useState } from "react";
import { OxygenTableFlowImporter } from "@/react/components/tableflow/OxygenTableFlowImporter";
import UploadIcon from "@8x8/oxygen-icon/icons/UploadIcon";
import {
  mapTableFlowColumns,
  mapTableFlowImportedRows,
} from "@/react/components/table/components/file-actions/tableflow-adapter";
import styled from "styled-components";
import { FlexPointerContainer } from "@/react/components/table/components/file-actions/styled";

const StyledUploadIcon = styled(UploadIcon)`
  margin-right: 16px;
`;

const UpdateRowsFromFile = ({
  columns,
  rows,
  bulkUpdateRows,
  identifierColumnId,
  schema,
  processInput,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCsvFileSelected = useCallback(
    ({ rows }) => {
      const rowsToUpdateMap = mapTableFlowImportedRows(
        rows,
        columns,
        schema,
        identifierColumnId
      );
      setIsOpen(false);
      processInput && processInput(rowsToUpdateMap, schema);
      bulkUpdateRows(identifierColumnId, rowsToUpdateMap, schema);
    },
    [columns, bulkUpdateRows, rows, schema, setIsOpen]
  );

  const importerColumns = useMemo(
    () => mapTableFlowColumns(columns, identifierColumnId),
    [columns]
  );

  return (
    <FlexPointerContainer onClick={() => setIsOpen(true)}>
      <StyledUploadIcon size={18} />
      <span>Bulk Update</span>
      <OxygenTableFlowImporter
        modalIsOpen={isOpen}
        modalOnCloseTriggered={() => setIsOpen(false)}
        skipHeaderRowSelection={true}
        onComplete={handleCsvFileSelected}
        template={{
          columns: importerColumns,
        }}
      />
    </FlexPointerContainer>
  );
};

export default memo(UpdateRowsFromFile);
